import '@vaadin/custom-field';
import '@descope-ui/descope-autocomplete-field';
import './descope-address-field-internal';

import { componentName, AddressFieldClass } from './AddressFieldClass';

customElements.define(componentName, AddressFieldClass);

export { AddressFieldClass, componentName };
